(function (biz) {
  'use strict';

  (() => {
    /*
     * Init <tk-site-search> Custom Elements
     */
    const elements = Array.from(document.querySelectorAll('tk-site-search'));
    const searches = elements.map(element => new biz.SiteSearchElement(element));
  })();

}(biz));
//# sourceMappingURL=init.es6.js.map
